/* Netto/Brutto-Umschalter.
 *
 * Das Skript aendert keine Preise. Beide Betraege stehen serverseitig im Markup
 * (snippets/price.liquid ueber snippets/md-net-price.liquid); welcher fuehrt,
 * entscheidet allein die Klasse md-price-net auf <html>, ausgewertet in
 * assets/custom.css.
 *
 * Die Erkennung "kommt der Besucher von Google?" passiert bewusst nicht hier,
 * sondern im synchronen Head-Schnipsel von layout/theme.liquid: Ein defer-Skript
 * laeuft erst nach dem Parsen, der erste Paint zeigte dann kurz den falschen
 * fuehrenden Preis. Hier wird das Ergebnis aus window.mdPrice nur uebernommen.
 *
 * KEEP IN SYNC: Cookie-Name und Klassenname mit layout/theme.liquid,
 * assets/custom.css und snippets/md-price-switch.liquid.
 */
(function () {
  'use strict';

  var HTML_CLASS = 'md-price-net';
  var COOKIE = 'md_price_mode';
  var COOKIE_TAGE = 30;
  var EVENT = 'md:pricemode';
  var SESSION_KEY = 'mdPriceFromGoogle';

  var state = window.mdPrice || { enabled: false, mode: 'gross', userChoice: false };
  if (!state.enabled) return;

  function writeChoice(mode) {
    var ablauf = new Date();
    ablauf.setTime(ablauf.getTime() + COOKIE_TAGE * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE + '=' + mode +
      ';expires=' + ablauf.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  /* Der Merker aus dem Head-Schnipsel haelt brutto fuer eine Sitzung fest,
   * nachdem der Feed-Parameter utm_medium=product_sync gesehen wurde -- und
   * steht dort ueber dem Cookie. Bliebe er nach einem Klick liegen, waere der
   * Umschalter fuer Feed-Besucher wirkungslos: Auf der aktuellen Seite wuerde er
   * greifen, beim naechsten Seitenaufruf ueberstimmt der Merker den frisch
   * geschriebenen Cookie wieder.
   *
   * Nur bei einem echten Klick loeschen, nicht beim Uebernehmen des Zustands
   * beim Laden -- sonst waere er nach der ersten Seite ohnehin weg und der
   * zweite Artikel zeigte netto. */
  function forgetFeedSession() {
    try {
      window.sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  // Nur aria-pressed wird hier gesetzt. Das Aussehen des aktiven Buttons haengt
  // in CSS an html.md-price-net und stimmt damit schon vor dem ersten Skriptlauf.
  function syncSwitches() {
    var buttons = document.querySelectorAll('[data-md-price-switch] [data-md-price-target]');
    for (var i = 0; i < buttons.length; i += 1) {
      var ziel = buttons[i].getAttribute('data-md-price-target');
      buttons[i].setAttribute('aria-pressed', ziel === state.mode ? 'true' : 'false');
    }
  }

  function setMode(mode, vomNutzer) {
    if (mode !== 'net' && mode !== 'gross') return;

    var geaendert = state.mode !== mode;
    state.mode = mode;

    if (vomNutzer) {
      state.userChoice = true;
      writeChoice(mode);
      forgetFeedSession();
    }

    document.documentElement.classList.toggle(HTML_CLASS, mode === 'net');
    syncSwitches();

    if (geaendert) {
      // Verbraucher: md-volume-discount (Preiskopf, Staffeltabelle, Summe) und
      // mdzo-fbt (Bundle-Summe) rechnen ihre eigenen Betraege und koennen die
      // Betonung nicht per CSS drehen.
      document.dispatchEvent(new CustomEvent(EVENT, {
        detail: { mode: mode, userChoice: state.userChoice }
      }));
    }
  }

  // Delegiert am document, damit auch Umschalter greifen, die erst spaeter im
  // DOM landen -- der Warenkorb kommt bei jeder Mengenaenderung ueber die
  // Section Rendering API frisch vom Server.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-md-price-target]');
    if (!btn || !btn.closest('[data-md-price-switch]')) return;
    e.preventDefault();
    setMode(btn.getAttribute('data-md-price-target'), true);
  });

  // Neu gerenderte Abschnitte bringen ihre Buttons mit aria-pressed="true" am
  // Brutto-Button (Server-Default) mit und muessen nachgezogen werden.
  document.addEventListener('shopify:section:load', syncSwitches);
  document.addEventListener('on:line-item:change', syncSwitches);
  document.addEventListener('on:cart:add', syncSwitches);

  window.mdPrice.setMode = function (mode) { setMode(mode, true); };

  syncSwitches();
})();
